import { expired, fact, listing, request } from "../../common/api";
import { feedSnapshot } from "../../common/feedSnapshot";
export default class FactFeedState {
  stories = [];
  loading = false;
  failed = false;
  missing = false;
  removed = false;
  startIndex = 0;
  async init(id) {
    const snapshot = feedSnapshot(id);
    if (snapshot) {
      this.stories = snapshot.stories.filter(story => !expired(story));
      this.next = snapshot.next;
    } else {
      do {
        await this.more();
      } while (!this.removed && !this.failed && this.next !== null && id && !this.stories.some(story => story.id === id));
    }
    const index = this.stories.findIndex(story => story.id === id);
    this.startIndex = Math.max(0, index);
    this.missing = !!id && index < 0 && !this.failed;
  }
  async more() {
    if (this.removed || this.loading || this.next === null) return;
    this.loading = true;
    this.failed = false;
    try {
      const page = listing(await request("?scope=public" + (this.next ? "&before=" + this.next : "")), fact);
      if (this.removed) return;
      const ids = new Set(this.stories.map(story => story.id));
      this.stories.push(...page.data.filter(story => !expired(story) && !ids.has(story.id)));
      this.next = page.next;
    } catch {
      if (!this.removed) this.failed = true;
    } finally {
      this.loading = false;
    }
  }
  remove() {
    this.removed = true;
  }
}
flarum.reg.add('xgay-fact', 'forum/states/FactFeedState', FactFeedState);